.scroll-container {
    max-height: 350px;
    overflow-y: auto;
}
